import editor from './editor'
import common from './common'
import component from './component'
import carousel from './carousel'
import navigation from './navigation'
import fullText from './fullText'
import mediaAndText from './mediaAndText'
import photoWall from './photoWall'
import jobList from './jobList'
import form from './form'
import navigationPage from './navigationPage'
import videoNavigation from './videoNavigation'

export default {
  editor,
  common,
  component,
  carousel,
  navigation,
  fullText,
  mediaAndText,
  photoWall,
  jobList,
  form,
  navigationPage,
  videoNavigation
}
